import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { moment, getHCMCityCoordinates, stypes } from "../common/common";
import { commonErr } from "../common/errors";
import {
	parseAddressToLocationWithLatLng,
	calculateDistance,
	parseWdMinHour,
	checkWdMinHour,
	setCookiesRoutes,
	getCookiesRoutes,
	getDurationTime,
	getEndDatewd,
} from "../common/wdfunction";

import serv_1 from "../../static/images/landingpage/service/gia_thue_xe_tu_lai_4cho_tai_hanoi.png";
import serv_2 from "../../static/images/landingpage/service/thue_xe_oto_tu_lai_va_co_tai.png";

class OurService extends React.Component {
	constructor() {
		super();

		this.state = {
			address: "Hồ Chí Minh",
			locAddress: Buffer.from(
				`${getHCMCityCoordinates.lat.toString()}-${getHCMCityCoordinates.lng.toString()}`
			).toString("base64"),
			lat: getHCMCityCoordinates.lat,
			lng: getHCMCityCoordinates.lng,
		};
	}

	findCar = (stype) => {
		const { address, lat, lng, locAddress } = this.state;

		const wdLocations = `${lat}-${lng}-${Buffer.from(address).toString("base64")}`;

		const isCityTourMode = true;
		const addressArray = [address, ""];
		let durationTimeArr = [0, 4, 6, 8, 10, 12, 16, 24, 36, 48, 60];
		const selectHour = durationTimeArr[1];

		if (stype === stypes.SD) {
			window.history.pushState(
				{ prevUrl: window.location.href },
				null,
				`/find/filter?address=${address}&loc=${locAddress}`
			);
			window.location.reload();
		} else {
			window.history.pushState(
				{ prevUrl: window.location.href },
				null,
				`/withdriver/find/filter?address=${
					addressArray.includes("") ? addressArray[0] : addressArray.join(";")
				}&isCityTourMode=${isCityTourMode}&selectHour=${selectHour}`
			);
			window.location.reload();
		}

		setCookiesRoutes({
			isCityTourMode: true,
			wdOneWay: false,
			wdDistance: 0,
			wdDistanceOW: 0,
			wdDistanceBackOW: 0,
			wdLocations,
		});
	};

	render() {
		const { address, lat, lng, locAddress } = this.state;
		const { title } = this.props;
		const isCityTourMode = true;
		const addressArray = [address, ""];
		let durationTimeArr = [0, 4, 6, 8, 10, 12, 16, 24, 36, 48, 60];
		const selectHour = durationTimeArr[1];

		return (
			<div className="service-section space sec">
				<div className="m-container">
					<h2
						className={`textAlign-center`}
						dangerouslySetInnerHTML={{ __html: title ? title : `Dịch Vụ Của&nbsp;Mioto` }}
					/>
					<div className="service-container">
						<div className="service-item">
							<div className="service-item__img">
								<img loading="lazy" src={serv_1} alt="gia_thue_xe_tu_lai_4cho_tai_hanoi" />
								<div className="content">
									<h3>
										Xe đã sẵn sàng.
										<br />
										Bắt đầu hành trình ngay!
									</h3>
									<p>
										Tự tay cầm lái chiếc xe bạn yêu thích <br /> cho hành trình thêm hứng khởi.
									</p>
									{/* <Link
										to={{
											pathname: "/find/filter",
											search: `address=${address}&loc=${locAddress}`,
										}}
										className="btn btn--l btn-primary">
										Thuê xe tự lái
									</Link> */}
									<a className="btn btn-primary btn--l" onClick={() => this.findCar(stypes.SD)}>
										Thuê xe tự lái
									</a>
								</div>
							</div>
						</div>
						<div className="service-item right">
							<div className="service-item__img">
								<img loading="lazy" src={serv_2} alt="thue_xe_oto_tu_lai_va_co_tai" />
								<div className="content">
									<h3>Tài xế của bạn đã đến!</h3>
									<p>
										Chuyến đi thêm thú vị <br /> cùng các bác tài 5* trên Mioto.
									</p>
									{/* <Link
										className="btn btn-primary btn--l"
										onClick={this.findCar}
										to={{
											pathname: `/withdriver/find/filter`,
											search: `address=${
												addressArray.includes("") ? addressArray[0] : addressArray.join(";")
											}&isCityTourMode=${isCityTourMode}&selectHour=${selectHour}`,
										}}>
										Thuê xe có tài xế
									</Link> */}
									<a className="btn btn-primary btn--l" onClick={() => this.findCar(stypes.WD)}>
										Thuê xe có tài xế
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="service-swiper-container">
						<Swiper
							className="swiper-service"
							slidesPerView={1}
							spaceBetween={10}
							modules={[Pagination]}
							pagination={{
								el: ".pagi-service",
								clickable: true,
								dynamicBullets: true,
							}}>
							<SwiperSlide>
								<div className="fix-img">
									<img loading="lazy" src={serv_1} alt="gia_thue_xe_tu_lai_4cho_tai_hanoi" />
								</div>
								<div className="content">
									<h3>
										Xe đã sẵn sàng.
										<br />
										Bắt đầu hành trình ngay!
									</h3>
									<p>
										Tự tay cầm lái chiếc xe bạn yêu thích <br /> cho hành trình thêm hứng khởi.
									</p>
									<Link
										to={{
											pathname: "/find/filter",
											search: `address=${address}&loc=${locAddress}`,
										}}
										className="btn btn--l btn-primary abc">
										Thuê xe tự lái
									</Link>
								</div>
							</SwiperSlide>
							<SwiperSlide className="right">
								<div className="fix-img">
									<img loading="lazy" src={serv_2} alt="thue_xe_oto_tu_lai_va_co_tai" />
								</div>
								<div className="content">
									<h3>Tài xế của bạn đã đến!</h3>
									<p>
										Chuyến đi thêm thú vị <br /> cùng các bác tài 5* trên Mioto.
									</p>
									<Link
										className="btn btn-primary btn--l"
										onClick={this.findCar}
										to={{
											pathname: `/withdriver/find/filter`,
											search: `address=${
												addressArray.includes("") ? addressArray[0] : addressArray.join(";")
											}&isCityTourMode=${isCityTourMode}&selectHour=${selectHour}`,
										}}>
										Thuê xe có tài xế
									</Link>
								</div>
							</SwiperSlide>
							<div className="swiper-pagination pagi-service" />
						</Swiper>
					</div>
				</div>
			</div>
		);
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

OurService = connect(mapState)(OurService);

export default OurService;
